import { Link, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import { FormEvent, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FORGOT_PASSWORD_PATH } from '../../constants/api.constants';
import { signInStart } from '../../store/auth/auth.action';
import MainLogo from '../ui/main-logo/main-logo.component';

const LoginForm = () => {
    const dispatch = useDispatch();

    const emailInput = useRef<HTMLInputElement>(null);
    const passwordInput = useRef<HTMLInputElement>(null);

    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [emailHelperText, setEmailHeplerText] = useState('');
    const [passwordHelperText, setPasswordHelperText] = useState('');

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setEmailError(false);
        setPasswordError(false);
        if (!emailInput.current?.value) {
            setEmailError(true);
            setEmailHeplerText('Email obbligatoria');
        }
        if (!passwordInput.current?.value) {
            setPasswordError(true);
            setPasswordHelperText('Password obbligatoria');
        }
        if (!emailInput.current?.value || !passwordInput.current?.value) {
            return;
        }
        try {
            dispatch(
                signInStart(
                    emailInput.current?.value,
                    passwordInput.current?.value,
                    () => {}
                )
            );
        } catch (error) {
            console.log('user sign in failed', error);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                <MainLogo />
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Indirizzo email"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        error={emailError}
                        helperText={emailHelperText}
                        inputRef={emailInput}
                        sx={{
                            '& .MuiFormLabel-root': {
                                fontWeight: 'bold',
                            },
                        }}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        error={passwordError}
                        helperText={passwordHelperText}
                        inputRef={passwordInput}
                        sx={{
                            '& .MuiFormLabel-root': {
                                fontWeight: 'bold',
                            },
                        }}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2,
                            color: 'info.main',
                            fontWeight: 'bold',
                            lineHeight: '1.5',
                        }}
                    >
                        Accedi
                    </Button>
                    <Typography align="center" sx={{ mt: 2 }}>
                        Hai dimenticato la password?{' '}
                        <Link
                            href={`${FORGOT_PASSWORD_PATH}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                            sx={{ fontWeight: 'bold', color: 'primary.main' }}
                        >
                            Clicca qui
                        </Link>
                    </Typography>
                </Box>
                <Box />
            </Box>
        </Container>
    );
};

export default LoginForm;
